import { render } from "./Notifications.vue?vue&type=template&id=7ee092c8&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=7ee092c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ee092c8"

export default script